import { render, staticRenderFns } from "./ProdutosHeranca.vue?vue&type=template&id=4c1244fc&scoped=true"
import script from "./ProdutosHeranca.vue?vue&type=script&lang=js"
export * from "./ProdutosHeranca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1244fc",
  null
  
)

export default component.exports